import {
  BankDataTypes,
  CreateBankParams,
  GetProvinceByBankParamTypes,
  ProvinceByBankItemTypes
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllBankService = async (
  params?: BaseFilterParams & {
    _name?: string;
    _provinceCode?: string
  },
): Promise<APIPaginationResponse<BankDataTypes[]>> => {
  const res = await axiosInstance.get('banks', { params });
  return res.data;
};

export const getBankByIdService = async (
  id: number,
): Promise<BankDataTypes> => {
  const res = await axiosInstance.get(`banks/${id}`);
  return res.data.data;
};

export const createBankService = async (
  params: CreateBankParams,
): Promise<void> => {
  await axiosInstance.post('banks', params);
};

export const updateBankService = async (
  params: CreateBankParams & { id: number },
): Promise<void> => {
  const { id, ...rest } = params;
  await axiosInstance.put(`banks/${id}`, rest);
};

export const deleteBanksService = async (params: { ids: number[] })
  : Promise<void> => {
  const res = await axiosInstance.delete('banks', { data: params });
  return res.data;
};

export const getProvinceByBankNameService = async (
  params?: GetProvinceByBankParamTypes
): Promise<APIPaginationResponse<ProvinceByBankItemTypes[]>> => {
  const res = await axiosInstance.get('banks/provinces', { params });
  return res.data;
};

export const getBankDefaultService = async (): Promise<BankDataTypes> => {
  const res = await axiosInstance.get('banks/default');
  return res.data.data;
};
